export default "images/carrot.svg";